import { Component, EventEmitter, Input, OnInit, Output, NgModule } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InboxDialogComponent } from '../components/inbox.dialog.component';
import { DataHelper } from '@helpers/data.helper';
@Component({
  selector: 'inbox-component',
  templateUrl: '../sharedTemplates/inbox.component.html',
})
export class InboxComponent {
  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    public dialog: MatDialog,
    public _DataHelper: DataHelper
  ) {}

  ngAfterViewInit() {
    if (this._UiHelper.rightMenu) this._UiHelper.setRightMenu();

    this._UiHelper.setLoadingDialog(false);
    this._UiHelper.setNavbarTitle('Support', true);
    this.getCustomerTicket();
  }

  getCustomerTicket() {
    this._ApiService.getCustomerTicket().then(CustomerTicketList => {
      this._DataHelper.DataCustomerTicketList = CustomerTicketList;
      //////console.log("D", this._DataHelper.DataCustomerTicketList);
    });
  }

  getCustomerTicketDetail(ticketid, subject) {
    this._UiHelper.setLoadingDialog(true);
    this._router.navigate(['/ticketdetail', ticketid, subject]);
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(InboxDialogComponent, {
      width: '300px',
      data: { data_ActivityCode: 2, data_TicketId: 0, data_Title: '' },
    });
  }
}
